import axios from 'axios';

const path = '/api/user/donnaTenantDetails';

const isInsuredMineEnabled = async () => {
  let response = {};
  let insuredMineEnabled = false;
  try {
    const { status, data } = await axios.get(path);
    const { error, data: tenantDetails } = data;
    if (status !== 200 || error) {
      throw new Error('Error getting donna tenant details');
    }
    const { insuredMineEnabled: insuredMineEnabledValue } = tenantDetails;

    if (typeof insuredMineEnabledValue !== 'boolean') {
      insuredMineEnabled = insuredMineEnabledValue === 'true' ? true : false;
    } else {
      insuredMineEnabled = insuredMineEnabledValue;
    }
    response = {
      error: false,
      data: {
        insuredMineEnabled,
      },
    };
  } catch (error) {
    response = {
      error: true,
      errorMessage: error.message,
    };
  }
  return response;
};

export default isInsuredMineEnabled;
